import React from 'react';
import { format, parseISO } from 'date-fns';

import LayoutFermerEnregistrement from '../layout.js';
import CustomInputWithCalendar from '../connecte/custum-input-calendrier.js';
import TimeInput from '../connecte/time-input.js';

import loadingImage from '../../../../images/loading.svg';

import { PATH_FERMER_ENREGISTREMENT } from '../../../constants/navigation-constants.js';

import '../style.css';
import '../../fermer-enregistrement-capture/style.css';

const FermerEnregistrementFormBase = ({
  texts,
  goTo,
  location,
  isLoading,
  loadError,
  enregistrementEntete,
  dataLoading,
  calendarRef,
  date,
  isOpenCalendar,
  setIsOpenCalendar,
  setdateIsSelected,
  minSelectableDate,
  maxSelectableDate,
  dateErrorKey,
  handleDateChange,
  dateIsSelected,
  handleTimeChange,
  children,
}) => {
  const dateError = dateErrorKey ? texts[dateErrorKey] : '';

  return (
    <LayoutFermerEnregistrement custmeClass={'fermer-enregistrement-capture-container'}>
      {
        isLoading ?
          <img style={{ height: "100%", filter: "brightness(0) saturate(100%) invert(90%) sepia(1%) saturate(20%) hue-rotate(290deg) brightness(104%) contrast(100%)" }} src={loadingImage} alt={texts.loadingAlt} />
          :
          <div className='fermer-enregistrement-content'>
            <button
              type="button"
              className="fec-back-btn"
              onClick={() => goTo(PATH_FERMER_ENREGISTREMENT)}
            >
              {texts.backToList}
            </button>

            <div className="title-section"><span className="droit-acces-span">{texts.pageTitle}</span></div>

            {loadError &&
              <div className="fec-load-error">{loadError}</div>
            }

            {!enregistrementEntete && !dataLoading &&
              <div className="fec-load-error">
                {texts.selectEnregistrementError}
              </div>
            }

            {enregistrementEntete &&
              <div
                // className="content-body"
              >
                {(location?.state?.noEnregistrement || location?.state?.dateArrive || location?.state?.dateDepart) &&
                  <div className="fec-enregistrement-dates">
                    {location?.state?.noEnregistrement &&
                      <div className="fec-date-depart-hint">
                        <span className="fec-enregistrement-date-label">{texts.numeroLabel}</span>
                        <span>{location.state.noEnregistrement}</span>
                      </div>
                    }
                    {location?.state?.dateArrive &&
                      <div className="fec-date-depart-hint">
                        <span className="fec-enregistrement-date-label">{texts.dateArriveeLabel}</span>
                        <span>{format(parseISO(location.state.dateArrive), 'yyyy-MM-dd HH:mm')}</span>
                      </div>
                    }
                    {location?.state?.dateDepart &&
                      <div className="fec-date-depart-hint">
                        <span className="fec-enregistrement-date-label">{texts.dateDepartLabel}</span>
                        <span>{format(parseISO(location.state.dateDepart), 'yyyy-MM-dd HH:mm')}</span>
                      </div>
                    }
                  </div>
                }
                <CustomInputWithCalendar
                  texts={texts}
                  dateSelected={date}
                  calendarRef={calendarRef}
                  isOpenCalendar={isOpenCalendar}
                  minDate={minSelectableDate}
                  maxDate={maxSelectableDate}
                  error={dateError}
                  initialMonth={location?.state?.dateDepart ? parseISO(location.state.dateDepart) : null}
                  onChangeValue={handleDateChange}
                  setIsOpenCalendar={(value) => setIsOpenCalendar(value)}
                  setdateIsSelected={(value) => setdateIsSelected(value)}
                />

                {dateIsSelected &&
                  <TimeInput
                    texts={texts}
                    date={date}
                    onChangeValue={(hours, mins) => handleTimeChange(hours, mins)}
                  />
                }

                {!dateErrorKey && children}
              </div>
            }
          </div>
      }
    </LayoutFermerEnregistrement>
  );
};

export default FermerEnregistrementFormBase;
